module.exports = __webpack_public_path__ + "media/images/flags/si-7f576d8798a8732afa465065bff56a6b.svg";